import { observer } from 'mobx-react-lite'
import { Button, Dropdown, DropdownContent } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { IClickToText } from 'entities/ClickToText'
import { downloadQRCodeAsPNG, downloadQRCodeAsSVG } from 'pages/clickToText/lib'

type IQRDownloadButtonProps = {
  qrCode: string
  clickToText?: IClickToText
}

export const QRDownloadButton = observer(({ qrCode, clickToText }: IQRDownloadButtonProps) => {
  const entities = useEntitiesContext()
  const { eventLogStore, organizationStore } = entities

  const handleDownload = (format: 'SVG' | 'PNG') => {
    eventLogStore.logEvent(
      'Click to Text Used',
      {
        event_id: 'click_to_text_used',
        action: 'Download clicked',
        linkId: clickToText?.id,
        agencyId: organizationStore.agency_id,
      },
      { groupId: organizationStore.id }
    )
    if (format === 'SVG') {
      downloadQRCodeAsSVG(qrCode)
    } else {
      downloadQRCodeAsPNG(qrCode)
    }
  }

  return (
    <Dropdown
      placement='bottom-start'
      ariaLabel='QR Download'
      customComponent={(onCloseMenu) => (
        <DropdownContent noPadding width={137}>
          <Button
            text='Download SVG'
            typeBtn='menuItem'
            onClick={() => {
              handleDownload('SVG')
              onCloseMenu?.()
            }}
          />
          <Button
            text='Download PNG'
            typeBtn='menuItem'
            onClick={() => {
              handleDownload('PNG')
              onCloseMenu?.()
            }}
          />
        </DropdownContent>
      )}
      triggerComponent={() => (
        <Button
          size='small'
          contained='tertiary'
          text='Download'
          typeBtn='contained'
          aria-label='Download QR Code'
        />
      )}
    />
  )
})
